// @flow
import React from 'react';
import PropTypes from 'prop-types'
import { pure } from 'recompose';
import moment from 'moment';
import classnames from 'classnames';
import styled from 'styled-components';
import colors from '../ui/colors';

const propTypes = {
  date: PropTypes.instanceOf(moment),
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

const defaultProps = {};

const StyledDay = styled.li`
  width: calc(100%/7.001);
  position: relative;

  &:before {
    content: '';
    width: 100%;
    padding-top: 100%;
    position: relative;
    display: block;
  }

  & > button {
    background: transparent;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: inline-block;
    padding: 0;
    font-size: inherit;
    font-family: inherit;
    font-weight: 400;
  }
  
  &.disabled > button {
    color: #C1C1C1;
    font-weight: normal;
  }

  &:not(.disabled) > button {
    cursor: pointer;


    .current-input-touch & {
      &:active {
        background: ${colors.BRAND_GREEN};
        color: white;
      }
    }

    .current-input-mouse & {
      &:hover {
        background: ${colors.BRAND_GREEN};
        color: white;
      }
    }
  }

  &.in-range > button {
    background: ${colors.BRAND_GREEN};
    color: white;
  }

  &.in-hover-range > button {
    background: #7a9e50;
    color: white;
  }

  &.blocked > button {
    background: ${colors.BLOCKED};
    color: ${colors.GRAY_DARK};
  }

  &.blocked.disabled > button {
    background: #e6e5e5;
    color: #C1C1C1;
  }

  &:nth-child(7n) > button {
    border-right: 0;
  }
  
  &.selected > button {
    background: ${colors.BRAND_GREEN};
    color: white;
  }
`;

const Day = ({date, disabled, selected, blocked, inRange, inHoverRange, onClick, addHoverClasses, onHover, onMouseLeave}: {date:moment, disabled:boolean, selected:boolean, blocked:boolean, inRange:boolean, inHoverRange:boolean, onClick:any, addHoverClasses:boolean, onHover:any}) => {
  const dayClass = classnames({
    'disabled': disabled,
    'selected': selected,
    'in-range': inRange && !selected,
    'in-hover-range': inHoverRange && !selected,
    'blocked': blocked,
  });
  return (
    <StyledDay className={dayClass}>
      {addHoverClasses ? (
        <button
          onClick={onClick}
          onMouseEnter={onHover}
          onMouseOver={onHover}
          disabled={disabled}
        >
          {date.date()}
        </button>
      ) : (
        <button
          onClick={onClick}
          disabled={disabled}
        >
          {date.date()}
        </button>
      )}
    </StyledDay>
  );
};

Day.propTypes = propTypes;
Day.defaultProps = defaultProps;

export default pure(Day);



// WEBPACK FOOTER //
// ./src/modules/common/components/calendar/Day.js